import {
    FormControl,
    FormControlLabel,
    FormLabel,
    Radio,
    RadioGroup,
} from "@mui/material";
import { useContext, useState } from "react";

import { LanguageContext } from "src/contexts/language";
import { MapContext } from "src/contexts/map";
import { Type_Props_Input } from "src/types/input";
import { handleInputBlur } from "src/utils/element";

const RadioTextField = ({ data }: Type_Props_Input) => {
    const { language } = useContext(LanguageContext);
    const { newElement, updateNewElement } = useContext(MapContext);
    const [selectedValue, setSelectedValue] = useState(
        newElement?.data?.find((input) => input.input_id === data.id)?.value ||
            "",
    );

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSelectedValue(event.target.value);
    };

    if (!data) return null;

    return (
        <FormControl
            component="fieldset"
            onBlur={() =>
                handleInputBlur({
                    data,
                    selectedValue,
                    newElement,
                    updateNewElement,
                })
            }
        >
            <FormLabel component="legend">{data.title[language]}</FormLabel>
            <RadioGroup row value={selectedValue} onChange={handleChange}>
                {data.options?.map((option, index) => (
                    <FormControlLabel
                        key={index}
                        control={<Radio />}
                        label={option.label}
                        value={option.value}
                    />
                ))}
            </RadioGroup>
        </FormControl>
    );
};

export default RadioTextField;
